import type { MailEncryption, MailServerPreset } from "@/lib/types/mail";

type Props = {
  imap: MailServerPreset;
  smtp: MailServerPreset;
  onImapChange: (next: MailServerPreset) => void;
  onSmtpChange: (next: MailServerPreset) => void;
};

const ENCRYPTIONS: { value: MailEncryption; label: string }[] = [
  { value: "ssl", label: "SSL" },
  { value: "starttls", label: "STARTTLS" },
  { value: "tls", label: "TLS" },
];

function ServerBlock({
  title,
  server,
  onChange,
}: {
  title: string;
  server: MailServerPreset;
  onChange: (next: MailServerPreset) => void;
}) {
  return (
    <fieldset className="mail-form-info-box p-3">
      <legend className="px-1 text-xs font-semibold uppercase tracking-wide text-[var(--mail-muted)]">
        {title}
      </legend>
      <div className="mt-2 grid gap-2 sm:grid-cols-2">
        <label className="block text-sm sm:col-span-2">
          <span className="mb-1 block text-xs font-medium text-[var(--mail-text)]">Hôte</span>
          <input
            type="text"
            value={server.host}
            onChange={(e) => onChange({ ...server, host: e.target.value })}
            className="mail-form-input"
            placeholder="mail.example.com"
            autoComplete="off"
          />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block text-xs font-medium text-[var(--mail-text)]">Port</span>
          <input
            type="number"
            min={1}
            max={65535}
            value={server.port}
            onChange={(e) => onChange({ ...server, port: Number(e.target.value) || 0 })}
            className="mail-form-input"
          />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block text-xs font-medium text-[var(--mail-text)]">Chiffrement</span>
          <select
            value={server.encryption}
            onChange={(e) =>
              onChange({ ...server, encryption: e.target.value as MailEncryption })
            }
            className="mail-form-input"
          >
            {ENCRYPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </fieldset>
  );
}

export function ManualServerFields({ imap, smtp, onImapChange, onSmtpChange }: Props) {
  return (
    <div className="space-y-3">
      <ServerBlock title="Serveur entrant (IMAP)" server={imap} onChange={onImapChange} />
      <ServerBlock title="Serveur sortant (SMTP)" server={smtp} onChange={onSmtpChange} />
    </div>
  );
}
